export const IDENTIFICATION_REQUIRED_DEFAULT_MESSAGE =
  "Απαιτείται αυθεντικοποίηση";
export const YOU_NEED_TO_LOGIN_DEFAULT_MESSAGE =
  "Χρειάζεται να συνδεθείτε για να μπορέσετε να συνεχίσετε";
export const LOGIN_DEFAULT_LABEL = "Σύνδεση";
export const TAXIS_LOGIN_PAGE_URL = "/auth/e-sign-in";
export const LOCAL_STORAGE_KEY_NAME_APPLKINDID = "applKindId";
export const LOCAL_STORAGE_KEY_NAME_FOR_ME = "forMe";
